// extracted by mini-css-extract-plugin
export default {"identifierText":"use-mention-suggestions-module__identifierText--vdUed"};